export { renderBetButtonsRegular } from "./renderBetButtonsRegular"
export { renderMarketsRegular } from "./renderMarketsRegular"